var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import uniqBy from 'lodash/uniqBy';
import * as React from 'react';
import Dropdown from '../dropdown';
import { Styled } from './style';
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag(props) {
        var _this = _super.call(this, props) || this;
        _this.validateTagValue = function (val) {
            var validValue = val
                .replace(/^\W*|[^a-zA-Z0-9\-\s_]|\W*$/g, '')
                .trim()
                .replace(/\s+/g, '-') // replace all spaces with dash
                .replace(/^[^A-Za-z0-9]*([^A-Za-z0-9_-])*/g, '') // remove string does not start with character
                .replace(/([^A-Za-z0-9_-])*[^A-Za-z0-9]*?$/g, '') // remove string does not end with character
                .toLowerCase();
            return validValue;
        };
        _this.addItemHandler = function (event, data) {
            var validatedTag = _this.validateTagValue(data.value);
            var newTag = { text: validatedTag, value: validatedTag };
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { options: __spreadArrays(prevState.options, [newTag]) })); });
        };
        _this.changeHandler = function (event, data) {
            var validatedTagValue = data.value.map(function (tag) { return _this.validateTagValue(tag); });
            _this.props.onTagsChanged(validatedTagValue);
        };
        _this.state = {
            options: _this.props.tagsList,
            currentvalues: _this.props.currentTags,
        };
        return _this;
    }
    Tag.getDerivedStateFromProps = function (props, state) {
        if (props.tagsList !== state.options && props.currentTags !== state.currentvalues) {
            return {
                options: props.tagsList,
                currentvalues: props.currentTags,
            };
        }
        else if (props.tagsList === state.options && props.currentTags !== state.currentvalues) {
            return {
                currentvalues: props.currentTags,
            };
        }
        else if (props.tagsList !== state.options) {
            return {
                options: props.tagsList,
            };
        }
        // No state update necessary
        return null;
    };
    Tag.prototype.render = function () {
        var uniqueOptions = uniqBy(this.state.options, 'value');
        return (React.createElement(Styled, { isNoResult: this.state.currentvalues.length === this.props.tagsList.length },
            React.createElement(Dropdown, { disabled: this.props.disabled || false, closeOnBlur: true, additionLabel: "", placeholder: "No tags added yet", value: this.state.currentvalues, fluid: true, multiple: true, noResultsMessage: "", search: true, selection: true, allowAdditions: true, onChange: this.changeHandler, onAddItem: this.addItemHandler, options: uniqueOptions })));
    };
    return Tag;
}(React.Component));
export default Tag;
//# sourceMappingURL=index.js.map